import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
         <div className="section-title">
                  <span className="line"></span>
                  <h2>
                    EXPERIENCE <span>/ Career History</span>
                  </h2>
                </div>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2026 - present"
            iconStyle={{ background: '#ca003d', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">Fresh graduate</h3>
            <h4 className="vertical-timeline-element-subtitle">BUE, El shorouk</h4>
            <p>
              Graduated with a Bachelor of Computer Science degree with a focus on software engineering.
            </p>
          </VerticalTimelineElement>

                    <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2025 - 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title"> DevOps Diploma</h3>
            <h4 className="vertical-timeline-element-subtitle">CLS Learning Solutions</h4>
            <p>
               Completed rigorous training in modern DevOps workflows and infrastructure as code (IaC).
            </p>
          </VerticalTimelineElement>
                         <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2025 - 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Internship</h3>
            <h4 className="vertical-timeline-element-subtitle">Kites Software, Nasr City</h4>
            <p>
              Backend Development,Project Management
            </p>
          </VerticalTimelineElement>
                    <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2024 - 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title"> Back End (Java) Diploma</h3>
            <h4 className="vertical-timeline-element-subtitle">EraaSoft Academy, Nasr city</h4>
            <p>
              Developed practical skills designing and building enterprise-level backend software architectures using Java, the Spring
Framework, Spring Boot, and Hibernate.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;